import React from 'react';
import { MDBFooter } from 'mdb-react-ui-kit'; // Importing MDBootstrap Footer component

// Functional Footer component
function Footer() {
  return (
    // Wrapper div to add positioning and spacing to the footer
    <div className='' style={{ position: "relative", top: "20px" }}>  
    
      {/* MDBFooter component from mdb-react-ui-kit with light background and white text */}
      <MDBFooter bgColor='light' className='text-center text-lg-start text-white'>

        {/* Inner content of the footer with padding, background color, and rounded corners */}
        <div className='text-center p-2' style={{ backgroundColor: '#004aad', borderRadius: '10px' }}>
          
          {/* Footer text/content */}
          Hira Dental Lab Coventry UK © Copyright 2026. All Rights Reserved.
          
        </div>
        
      </MDBFooter>
    </div>
  );
}

export default Footer;
